import userLoggedIn from './scripts/user-logged-in';
import SiteMessagesInstance from './components/site-messages';
import serialize from 'form-serialize'
import getContacts from './scripts/get-contacts'
import sort from 'array-sort';
import AddContactModal from './components/add-contact-modal'
import getSensors from './scripts/get-sensors'
import CacheInstance from './components/cache'
import AccountUsers from './templates/account/users'
import History from './templates/account/history'
import AccountDisplayPreferences from './templates/account/display-preferences'
import DeleteAccount from './templates/account/delete-account'
import AccountCsvDownload from './templates/account/csv'
import AccountCsvSettings from './templates/account/csv'
import AccountEmailReports from './templates/account/email-reports'
import Branding from './components/branding'
import isAccountEnterprise from './scripts/is-account-enterprise'
import maybeBlacklistedOverlay from './components/maybe-blacklisted-overlay'

class Account {

  constructor () {

    this.page = document.querySelector('.account');

    this.startSection = null;
    this.currentSection = false;
    this.isMobile = false;
    this.events = {};

    if(this.page) {

      Branding.updateLogo();

      this.contacts = [];
      this.sensors = [];

      this.sections = {
        display_preferences: {
          name: 'Display',
          defaultIcon: '/assets/images/icon-account-display-black.svg',
          activeIcon: '/assets/images/icon-account-display-black.svg',
          show: true,
        },
        notifications: {
          name: 'Notifications',
          defaultIcon: '/assets/images/icon-account-notifications-black.svg',
          activeIcon: '/assets/images/icon-account-notifications-black.svg',
          show: false,
        },
        reports: {
          name: 'Reports',
          defaultIcon: '/assets/images/icon-account-reports-black.svg',
          activeIcon: '/assets/images/icon-account-reports-black.svg',
          show: true,
        },
        csv: {
          name: 'CSV Download',
          defaultIcon: '/assets/images/icon-account-csv-download.svg',
          activeIcon: '/assets/images/icon-account-csv-download.svg',
          show: true,
        },
        profile: {
          name: 'Profile',
          defaultIcon: '/assets/images/icon-account-profile-black.svg',
          activeIcon: '/assets/images/icon-account-profile-black.svg',
          show: true,
        },
        users: {
          name: 'Users',
          defaultIcon: '/assets/images/icon-users-black.svg',
          activeIcon: '/assets/images/icon-users-black.svg',
          show: false,
        },
        history: {
          name: 'History',
          defaultIcon: '/assets/images/icon-history-black.svg',
          activeIcon: '/assets/images/icon-history-black.svg',
          show: true,
        },
        login: {
          name: 'Login',
          defaultIcon: '/assets/images/icon-account-login-black.svg',
          activeIcon: '/assets/images/icon-account-login-black.svg',
          show: true,
        },
        password: {
          name: 'Password',
          defaultIcon: '/assets/images/icon-account-password-black.svg',
          activeIcon: '/assets/images/icon-account-password-black.svg',
          show: true,
        },
        developers: {
          name: 'Developers',
          defaultIcon: '/assets/images/icon-account-api-black.svg',
          activeIcon: '/assets/images/icon-account-api-black.svg',
          show: false,
        },
        help: {
          name: 'Support',
          defaultIcon: '/assets/images/icon-account-help-black.svg',
          activeIcon: '/assets/images/icon-account-help-black.svg',
          show: true,
        },
        debug: {
          name: 'Debug',
          defaultIcon: '/assets/images/icon-account-password-black.svg',
          activeIcon: '/assets/images/icon-account-password-black.svg',
          show: false,
        },
      }

      userLoggedIn().then(token => {

        if (token === false) {
          window.location.href = window.site.home + '/logout';
          return;
        }

        if(maybeBlacklistedOverlay()) {
          return;
        }

        this.wrapper = this.page.querySelector('.account-wrapper');
        this.container = this.page.querySelector('.account-container');
        this.sidebar = this.page.querySelector('.account-sidebar');
        this.content = this.page.querySelector('.account-content');

        this.developerApiKey = null;
        this.developerApiKeyHidden = true;
        this.developerShowApiKeyButton = this.page.querySelector('button[data-for="show-api-key"]');
        this.developerApiKeyEl = this.page.querySelector('.account-api-key');

        this.sidebarItemsContainer = this.sidebar.querySelector('.account-sidebar-items');

        $(this.content).find('.current-login-email').html(window.currentUser.email);

        this.AccountDisplayPreferences = new AccountDisplayPreferences(this.container.querySelector('.account-display-preferences'));

        this.events.display_preferences = {
          onSelect: this.AccountDisplayPreferences.init.bind(this.AccountDisplayPreferences)
        };

        this.AccountEmailReports = new AccountEmailReports(this);
        this.AccountCsvSettings = new AccountCsvSettings(this.container.querySelector('.account-csv-settings'));

        // delete account
        new DeleteAccount(this.container.querySelector('button[data-for="delete-account"]'));

        const deviceInfo = CacheInstance.get('device');
        const oneSignalData = CacheInstance.get('one-signal');

        // show sub users only to master account

        if(
          !window.currentUser.is_sub_user ||
          (window.currentUser.is_support_user && window.currentUser.is_support_user == 1)
        ) {

          this.sections.users.show = true;

          this.AccountUsers = new AccountUsers(this.page);

          this.events.users = {
            onSelect: this.AccountUsers.init.bind(this.AccountUsers)
          };

        }

        if(isAccountEnterprise()) {
          this.sections.login.show = false;
          this.sections.password.show = false;
          this.sections.profile.show = false;
        }

        // developers section display setting
        if(!window.currentUser.is_sub_user) {
          this.sections.developers.show = true;
        }

        this.History = new History(this.page);

        this.events.history = {
          onSelect: this.History.loadHistory.bind(this.History)
        };

        // show notifications section if device and onesignal are working
        if(deviceInfo && oneSignalData) {

          this.sections.notifications.show = true;
          this.initNotificationsSection();

        }

        if(
          window.currentUser.id == 51894 ||
          window.currentUser.id == 1 ||
          window.currentUser.id == 4 ||
          window.currentUser.id == 105363 ||
          window.currentUser.id == 9677 ||
          window.currentUser.id == 128981 ||
          window.currentUser.id == 121371
        ) {

          this.sections.debug.show = true;

          let devHtml = '';

          devHtml += `
          <h2>Switch Environment</h2>
          <p>Current: ${window.location.host}</p>
          `;

          if(window.location.host.includes('beta')) {
            devHtml += '<a href="https://temperaturestick.com" class="button">Switch to Live</a>';
          } else {
            devHtml += '<a href="https://beta.temperaturestick.com" class="button">Switch to Beta</a>';
          }

          devHtml += '<div class="divider"></div>';

          devHtml += `
          <h2>One Signal</h2>
          ${oneSignalData ? Object.keys(oneSignalData.value).map(key => {
            return `<li><b>${key}</b>: ${oneSignalData.value[key]}</li>`
          }).join('') : '<p>No One Signal information</p>'}
          `;

          devHtml += `
          <h2>Device</h2>
          ${deviceInfo ? Object.keys(deviceInfo.value).map(key => {
            return `<li><b>${key}</b>: ${deviceInfo.value[key]}</li>`
          }).join('') : '<p>No device information</p>'}
          `;

          $(this.content).find(`.debug-content`).html(devHtml);

        }

        let sidebarItemHtml = '';

        Object.keys(this.sections).forEach(sectionId => {

          const section = this.sections[sectionId];

          if(section.show) {
            sidebarItemHtml += `
            <button class="account-sidebar-item" data-for="${sectionId}">
              <img src="${section.defaultIcon}" width="20" alt="icon"> ${section.name}
            </button>
            `;
          }

        });

        $('.account-sidebar-items').html(sidebarItemHtml);

        this.sidebarItems = Array.from(this.sidebar.querySelectorAll('.account-sidebar-item'));

        $(this.sidebar).on('click', '.account-sidebar-item', e => {

          this.selectSection(e.currentTarget.dataset.for);

        });

        $(this.content).on('click', '.account-section-back-button', () => {
          this.mobileBackButton();
        });

        this.loadData();

        const url = new URL(window.location);

        if(url.searchParams.get('section')) {

          if(this.sections[url.searchParams.get('section')]) {
            this.startSection = url.searchParams.get('section');
          }

        } else if(window.location.hash) {

          // use hash history for remembering sections
          let hash = window.location.hash.replace('#', '');

          if(this.sections[hash]) {
            this.startSection = hash;
          }

        }


        if(url.searchParams.get('reload')) {
          url.searchParams.delete('reload');

          setTimeout(() => {
            window.location.href = url.href;
          }, 100);

          return;

        }

        if(window.innerWidth < 800) {
          this.initMobile();
        } else {
          this.init();
        }

        this.initForms();

        window.PubSub.subscribe('window.resize', (msg, width) => {

          if(width < 800) {
            if(!this.isMobile) {
              this.initMobile();
            }
          } else {
            if(this.isMobile) {
              this.init();
            }
          }

        });

        this.interactions();

        // remove loading animation
        $(this.sidebar).removeClass('loading-overlay');
        $(this.content).find('.account-content-section[data-for="loading"]').remove();

      });

    }

  }

  interactions() {

    $(this.developerShowApiKeyButton).on('click', this.maybeToggleApiKey.bind(this));

  }

  maybeToggleApiKey() {

    if(!this.developerApiKey) {

      $(this.developerShowApiKeyButton).attr('disabled', true);
      this.developerApiKeyEl.classList.add('loading-overlay');

      window.apiRequest('get', '/user/api-key').then(r => {

        $(this.developerShowApiKeyButton).removeAttr('disabled');

        if(r.type === 'success') {

          this.developerApiKey = r.data.api_key;

          if (this.developerApiKey) {

            this.developerApiKeyEl.innerHTML = this.developerApiKey;
            this.developerApiKeyEl.classList.remove('loading-overlay');
            this.developerApiKeyEl.classList.remove('account-api-key--hidden');

          }

          $(this.developerShowApiKeyButton).removeAttr('disabled');

        } else {
          alert(r.message);

        }

      });

    }

    if(this.developerApiKeyHidden) {

      this.developerShowApiKeyButton.innerHTML = `
      Hide Key <i class="far fa-eye-slash"></i>
      `;

      this.developerApiKeyHidden = false;
      this.developerApiKeyEl.innerHTML = this.developerApiKey;
      this.developerApiKeyEl.classList.remove('account-api-key--hidden');

    } else {

      this.developerShowApiKeyButton.innerHTML = `
      Show Key <i class="far fa-eye"></i>
      `;

      this.developerApiKeyHidden = true;
      this.developerApiKeyEl.classList.add('account-api-key--hidden');

      this.developerApiKeyEl.innerHTML = `
        <i class="fas fa-circle"></i>
        <i class="fas fa-circle"></i>
        <i class="fas fa-circle"></i>
        <i class="fas fa-circle"></i>
        <i class="fas fa-circle"></i>
        <i class="fas fa-circle"></i>
        <i class="fas fa-circle"></i>
        <i class="fas fa-circle"></i>
        <i class="fas fa-circle"></i>
        <i class="fas fa-circle"></i>
      `;
    }

  }

  initNotificationsSection() {

    let deviceInfo = CacheInstance.get('device');
    if(deviceInfo) {
      deviceInfo = deviceInfo.value;
    }

    let onesignal = CacheInstance.get('one-signal');
    if(onesignal) {
      onesignal = onesignal.value;
    }

    const notificationSection = $('.account-content-section[data-for="notifications"]');

    let html = `
      <h4 class="section-title">
        <button type="button" class="account-section-back-button">
          <i class="far fa-arrow-left"></i>
        </button>

        Notifications

      </h4>
      <p>
        Receive alerts as push notifications on this device.  You can select which alerts send push notifications in 
        the <a href="${window.site.home}/alerts">alert settings</a>
      </p>`;

    if(onesignal && onesignal.oneSignalSubscribed == true) {
      html += '<p><b>You are subscribed to push notification alerts</b></p>';
    } else {
      html += '<p><b>Push notification alerts are blocked</b></p>';
    }

    html += `   
    <button class="button button--medium button--teal notification-settings-button">
      Open App Settings
    </button>
    <p class="text--smaller">
      <br />
      You can enable and disable notifications in your app settings.
    </p>    
    `;

    $(notificationSection).html(html);

    // reload when we come back to the app
    document.addEventListener('visibilitychange', function (event) {

      const isUpdating = CacheInstance.get('update-app-settings');

      if(!document.hidden && isUpdating) {
        CacheInstance.remove('update-app-settings');
        window.location.href = `${window.site.home}/account?section=notifications&reload=1`;
      }

    });

    // open app settings
    $(notificationSection).find('.notification-settings-button').on('click', () => {

      CacheInstance.save('update-app-settings', 1);
      window.location.href = 'gonative://open/app-settings';

    });

  }

  initForms() {

    const autosaveForms = [
      '/user/profile',
      '/user/display-preferences',
      '/user/email-reports',
    ];

    autosaveForms.forEach(formId => {

      const form = this.container.querySelector(`form[data-for="${formId}"]`);

      if(form) {

        let autosaveTimeout = null;

        $(form).on('change', () => {

          clearTimeout(autosaveTimeout);

          autosaveTimeout = setTimeout(() => {
            $(form).submit();
          }, 200);

        });

      } else {
        console.error(`${formId} is not set`);
      }

    });

    const forms = this.container.querySelectorAll('form');

    // disable form for no permissions user
    if(window.currentUser.level && window.currentUser.level == 0) {
      $(forms).find('button').attr('disabled', true);
    }

    $(this.container).find('.switch-input').on('change', e => {

      const toggle = e.currentTarget;
      const id = toggle.name;

      const conditionalContainer = $(this.container).find(`.setting--conditional[data-for="${id}"]`);
      conditionalContainer.toggleClass('is-active', $(toggle).is(':checked'));

    });

    // toggle the section based on loaded data
    $(this.container).find('.switch-input').each((i, toggle) => {
      const id = toggle.name;
      $(this.container).find(`.setting--conditional[data-for="${id}"]`).toggleClass('is-active', $(toggle).is(':checked'));
    });

    $(forms).on('change', e => {

      const form = e.currentTarget;
      const formId = $(form).data('for');

      if(!autosaveForms.includes(formId)) {

        const btn = form.querySelector('.save-button');
        const msg = form.querySelector('.save-message');

        $(btn).removeAttr('disabled');
        $(msg).html('');

      }

    });

    $(forms).on('submit', e => {

      e.preventDefault();

      // don't submit for no permissions user
      if(window.currentUser.level && window.currentUser.level == 0) {
        return;
      }

      let isAutosave = false;

      let btn = null;
      let msg = null;

      const form = e.target;
      const formId = $(form).data('for');

      if(autosaveForms.includes(formId)) {
        isAutosave = true;
      } else {
        btn = form.querySelector('.save-button');
        msg = form.querySelector('.save-message');

        $(btn).attr('disabled', true);
        $(msg).html('');

      }

      const data = serialize(form, {hash: true})

      if(formId === '/user/email-reports') {

        if(!data['send_reports']) {
          data['send_reports'] = 0;
        }

        if(!data['daily_reports']) {
          data['daily_reports'] = 0;
        }

        if(!data['weekly_reports']) {
          data['weekly_reports'] = 0;
        }

        if(!data['monthly_reports']) {
          data['monthly_reports'] = 0;
        }

      } else if(formId === '/user/display-preferences') {

        if(!data['chart_fill']) {
          data['chart_fill'] = 0;
        }

        if(!data['use_local_timezone']) {
          data['use_local_timezone'] = 0;
        }

        if(!data['timezone']) {
          data['timezone'] = window.currentUser.timezone;
        }

      }

      apiRequest('post', formId, data).then(r => {

        if(isAutosave) {
          if (r.type !== 'success' && formId !== '/user/email-reports') {
            alert(r.message);
          }
        } else {

          if(r.type === 'success') {

            // log out the user when the login email was changed (this should've already happened)
            if(formId === '/user/login') {
              SiteMessagesInstance.addMessage('success', 'Your login email has changed, please login with the new email');
              window.location.href = window.site.home + '/logout';
              return;
            }

          }

          $(msg).html(r.message);
        }

      }).catch(reason => {

        if(isAutosave) {
          alert('There was a problem trying to save')
        } else {
          $(msg).html('There was a problem completing this action');
          $(btn).removeAttr('disabled');
        }

      });

    });

  }

  loadData() {

    Promise.all(
      [
        getContacts(),
        getSensors()
      ]
    ).then(results => {

      this.contacts = sort(results[0], 'contact_name');
      this.sensors = sort(results[1], 'sensor_name');

      window.PubSub.publish("account.loaded");

    });

    const data = window.currentUser;

    Object.keys(data).forEach(key => {

      const control = $(this.container).find(`[name="${key}"]`);
      const autocomplete = control.attr('autocomplete');

      if(autocomplete && autocomplete === 'off') {
        return;
      }

      if(control.attr('type') === 'checkbox') {
        if(data[key] == 1 || data[key] == 'true') {
          control.attr('checked', true);
        }
      } else {

        switch(key) {
          case('password'):
            data[key] = '';
            break;
        }

        control.val(data[key]);

      }

    });

  }

  init() {

    if(this.isMobile) {

      // reset position
      $(this.container).css('transform', '');
      $(this.container).css('width', '');
      $(this.sidebar).css('width', '');
      $(this.content).css('width', '');

      this.isMobile = false;

    }

    const sectionId = this.startSection ? this.startSection : this.sidebarItems[0].dataset.for;
    this.selectSection(sectionId);

  }

  initMobile() {

    this.isMobile = true;

    // reset position
    $(this.container).css('transform', '');

    // leave room for scroll bar
    $(this.container).width((this.wrapper.clientWidth * 2));
    $(this.sidebar).width((this.container.clientWidth / 2) - 15);
    $(this.content).width((this.container.clientWidth / 2) - 15);

  }

  mobileBackButton() {

    this.sidebar.querySelector(`.account-sidebar-item[data-for="${this.currentSection}"]`).classList.remove('is-active');
    this.sidebar.querySelector(`.account-sidebar-item[data-for="${this.currentSection}"]`)
      .querySelector('img')
      .src = this.sections[this.currentSection].defaultIcon;

    const currentSection = this.currentSection;

    if(this.isMobile) {
      $(this.container).css('transform', `translate3d(0, 0, 0)`);

      setTimeout(() => {
        this.content.querySelector(`.account-content-section[data-for="${currentSection}"]`).classList.remove('is-active');
      }, 500);

    }

    this.currentSection = false;

  }

  selectSection(sectionId) {

    if(sectionId === this.currentSection) {
      return;
    }

    history.pushState(null, null, `#${sectionId}`);

    try {
      if (this.currentSection) {
        this.sidebar.querySelector(`.account-sidebar-item[data-for="${this.currentSection}"]`).classList.remove('is-active');

        this.sidebar.querySelector(`.account-sidebar-item[data-for="${this.currentSection}"]`)
          .querySelector('img')
          .src = this.sections[this.currentSection].defaultIcon;

        this.content.querySelector(`.account-content-section[data-for="${this.currentSection}"]`).classList.remove('is-active');
      }

      this.currentSection = sectionId;
      this.sidebar.querySelector(`.account-sidebar-item[data-for="${sectionId}"]`).classList.add('is-active');

      this.sidebar.querySelector(`.account-sidebar-item[data-for="${this.currentSection}"]`)
        .querySelector('img')
        .src = this.sections[this.currentSection].activeIcon;

      this.content.querySelector(`.account-content-section[data-for="${this.currentSection}"]`).classList.add('is-active');

      // on select event to do stuff when someone clicks a tab
      if (this.events[sectionId]) {

        if (this.events[sectionId].onSelect) {
          this.events[sectionId].onSelect();
        }

      }

      if (this.isMobile) {
        $(this.container).css('transform', `translate3d(-${(this.container.clientWidth / 2) + 15}px, 0, 0)`);
      }

    } catch (e) {
      console.error("Invalid section", sectionId);
      this.selectSection("display");
    }
  }

}

new Account();
